import React, { useEffect, useState } from "react";
import { Banner } from '../../components';
import { ClientsRow } from '../../components';
import { HeroIndustries } from '../../components';
import { IndustriesSpriteJpg } from '../../components';
import { IndustriesIframeBlock } from '../../components';
import { VideoFullSection } from '../../components';
import { VideoScroll } from '../../components';
import { IndustriesCarouselMenu } from '../../components';
import { VideoScrollAlone } from '../../components';
import { Loader } from '../../components';
import { imagesArray } from '../../sprites/Cpg';
import { BaseUrl } from "../../config";

const LandingCPGContainer = (props) => {

  const imgHeroIndustries = require('../../assets/hero-cpg.png');
  const sprites = imagesArray;
  const arrayLoad = [
    imgHeroIndustries,
    ...sprites
  ]
  const boxesArray = [
    {
      title: "Highest Quality",
      text: "Our ultra-realistic real-time rendered 3D Digital Twins are compliant to the most stringent of industry standards and created through our patented pipeline methodologies."
    },
    {
      title: "Active Experience",
      text: "We bring the digital experience to the highest level, comparable to the real-world experience where users can fully engage with the environment, products, and assets."
    },
    {
      title: "Growth Acceleration",
      text: "Transform and boost your business and company towards a “digital culture” and enable yourself to experience the enhanced opportunities of the full digital ecosystem."
    }
  ];

  const [listClients, setListClients] = useState([]);

  useEffect(() => {
    document.title = "Invrsion for CPG"
   
    fetch(`${BaseUrl}/page?key=invrsion&slug=cpg`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      setListClients(res.data.company.clients);
    })
    
    
  }, []);
  return (
    <React.Fragment>
      <HeroIndustries
        title="A new era for CPG starts here." 
        bgColor="linear-gradient(105.88deg, #E2B234 , #F4DD63 )" 
        img={imgHeroIndustries}
      />
      <IndustriesSpriteJpg 
        idScroll="2-cpg" 
        title="How our Full Reality solutions fulfill your needs" 
        black="#302908"
        boxesArray={boxesArray}
        imagesArray={sprites}
        iframeUrl="https://sketchfab.com/models/1c4b914e16c3462787d3225cb1750e83/embed?annotations_visible=0&amp;camera=0&amp;animation_autoplay=0&amp;autostart=0&amp;ui_controls=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_stop=0&amp;ui_watermark=0&amp;ui_watermark_link=0&amp;preload=1&amp;scrollwheel=0&amp;sound_enable=0&amp;ui_animations=0&amp;ui_annotations=0&amp;ui_ar=0&amp;ui_fadeout=0&amp;ui_fullscreen=0&amp;ui_help=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_settings=0&amp;ui_stop=0&amp;ui_theatre=0&amp;ui_vr=0&amp;pixel_budget=0"
        
      />      
      <div className="column--quote-wrap">
        <h6 className="big--title">We create tailormade CPG experiences to fit your specific business</h6>
      </div>
      <IndustriesIframeBlock 
        bgColor="#F4DD63"
        url="0088a401bdeb4f44a8f13509e409a470"
        title="3D e-commerce"
        black="#302908"
        route="/products/3d-commerce"
        zoom="35"
        mobileSrc={require('../../assets/iframe-placeholder/Lays_thumbnail.png')}
        text="Our solution to transform your online CPG goods into Full Reality 3D models for maximum engagement. Manipulate and see every detail of your products come to life, thanks to our house blend of advanced digitization techniques."
      />
      <VideoFullSection 
        bgColor="#F7EBAD"
        title="Retail Reality Unbound"
        black="#302908"
        route="/shelfzone"
        supTitle={"Shelfzone"}
        zIndex={2}
        text="The most sophisticated VR-ready SaaS 
retail simulation software and shelf optimization 
tool for your day-to-day planning and research."
      >
        <VideoScroll 
          idScroll="video-01-cpg" 
          video={require('../../assets/video/video-cpg-1.mp4')} 
        />
      </VideoFullSection>
      
      <IndustriesCarouselMenu
        colorCTA="#E2B234"
        black="#302908"
      >
        <h3 className="big--title" style={{color: '#302908'}}>
        We want consumers to be consumed by CPG
        </h3>
      </IndustriesCarouselMenu>
      <VideoScrollAlone
        idScroll="video-cpg-02"
        video={require('../../assets/video/video-case-cpg.mp4')} 
      />
      {
        listClients.length > 0 &&
        <ClientsRow 
        black="#302908"
        title="CPG brands that are already on board and trust in Invrsion's solutions"
        arrayClients={listClients}/>
      }
      <Banner bgColor="#F9F5DE" text="Intrigued? Let’s have a chat." route="/reach-out" copyRoute="Reach out" black="#302908"/>
      
      <Loader arrayLoad={arrayLoad} />
    </React.Fragment>
  );
};

export default LandingCPGContainer;
